import { render } from "./Modal.vue?vue&type=template&id=740a2c32&scoped=true"
import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"

import "./Modal.vue?vue&type=style&index=0&id=740a2c32&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-740a2c32"

export default script